'use client';

import { useIntersectionObserver } from '@packages/shared/src/hooks/useIntersectionObserver/useIntersectionObserver';
import type { RefObject, Dispatch, SetStateAction } from 'react';

export const useFixPositionOnScroll = (
  tooltipContentRef: RefObject<HTMLSpanElement | null>,
  setPositioningTooltip: Dispatch<
    SetStateAction<
      'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | null | undefined
    >
  >,
) => {
  useIntersectionObserver(tooltipContentRef, {
    intersectOnce: false,
    threshold: 1.0,
    callback: (isIntersecting, scrolledTop) => {
      if (!isIntersecting && !tooltipContentRef.current?.hidden) {
        setPositioningTooltip((prev) => {
          if (prev?.includes('top') && scrolledTop) {
            return prev.replace('top', 'bottom') as typeof prev;
          }
          if (prev?.includes('bottom') && !scrolledTop) {
            return prev.replace('bottom', 'top') as typeof prev;
          }
          return prev;
        });
      }
    },
  });
};
